<div class='employees'>
  <mat-card appearance="outlined" class="employee-card" [ngClass]="employee.jobCode !== 'ADVISOR'?'no-image':''">
    <mat-card-header>
      <mat-card-title>
        <div class="advisor-name">
          <span>{{employee.firstName | titlecase}} {{employee.lastName | titlecase}}</span>
          <span class="job-description">{{employee.jobDescription | titlecase}}</span>
          <span class="job-description" *ngIf="employee.isTxm">TXM</span>
        </div>
        <div *ngIf="employee.jobCode === 'ADVISOR'" class="advisor-image">
          <div *ngIf="employee.avatar && employee.avatar != ''" mat-card-avatar class="employee-header-image"
            [ngStyle]="{ 'background-image': (employee.avatar && employee.avatar != '' ? ('url(' + employee.avatar + '?date=' + currentDate + ')') : 'url('+('images/avatar.jpg' | assetUrl)+')' )}">
          </div>
          <div *ngIf="!(employee.avatar && employee.avatar != '')" class="d-flex ml-auto">
            <span class="avatar-initials">{{employee?.firstName?.charAt(0)?.toUpperCase() + employee?.lastName?.charAt(0)?.toUpperCase()}}</span>
          </div>
          <div class="visbility-icon" *ngIf="employee.visibility">
            <asp-icon class="asp-icon" name="ic-20-utility-visiblity.svg" width="19px" height="13px" color="inherit"></asp-icon>
          </div>
        </div>
        <div class="action" >
          <mat-icon [matMenuTriggerFor]="actionMenu">more_vert</mat-icon>
          <mat-menu #actionMenu="matMenu">
            <button mat-menu-item (click)="updateEmployee()">{{'servicePersonnel.editDetails'| translate}}</button>
            <button mat-menu-item (click)="openLeaveDialog()"> {{'servicePersonnel.daysOff'| translate}}</button>
          </mat-menu>
        </div>
      </mat-card-title>
      <mat-card-subtitle class="phone-number">
        {{employee.phone | phone}}<br/>
        {{'servicePersonnel.dmsId'| translate}} {{employee.externalId}}<br/>
        {{'servicePersonnel.spinId'| translate}} {{employee.spinId}}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-divider></mat-divider>
    <div class="content row">
      <div class="content-col">
        <div>{{employee.email | lowercase}}</div>
        <ng-container *ngIf="employee.jobCode === 'ADVISOR'">
          <div>{{getLanguageList()}}</div>
        </ng-container>
        <ng-container class='row' *ngIf="employee.jobCode === 'TECHNICIAN'">
          <span> {{'servicePersonnel.flatRateHoursObjective'| translate}} <span style="font-weight: bold;">{{employee.flatRateHours || 0}}</span></span>
        </ng-container>
      </div>
    </div>
  </mat-card>
</div>
